import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Prices on Metazik are always in dollars (international). To help an artist pick theirs,
 * this shows what the dollar amount typed comes to in the currencies fans actually pay with
 * (the same fixed rates as the checkout). */
let cache = null;
const LABEL = { XAF: "FCFA", XOF: "FCFA" };
const nf = (n) => String(Math.round(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export default function PriceEquivalents({ usd, className = "" }) {
  const [rates, setRates] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/payments/providers", { params: { currency: "USD" } }).then(({ data }) => {
      const seen = {};
      for (const p of data?.providers || []) if (p.rate && p.charge_currency && p.charge_currency !== "USD") seen[p.charge_currency] = p.rate;
      cache = seen;
      setRates(seen);
    }).catch(() => {});
  }, []);
  const value = parseFloat(String(usd).replace(",", "."));
  if (!rates || !(value > 0) || !Object.keys(rates).length) return null;
  return (
    <p className={`text-[11px] text-zinc-500 mt-1 ${className}`} data-testid="price-equivalents">
      {value} $ {Object.entries(rates).map(([cur, rate]) => `≈ ${nf(value * rate)} ${LABEL[cur] || cur}`).join(" · ")}
    </p>
  );
}
